<!-- Site footer -->
<footer ng *ngIf="!login" class="site-footer mt-4">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-3">
                <!-- <h6>Nosotros</h6> -->
                <p class="text-justify">Inmobiliaria Primo - <i>MAS DE 40 AÑOS </i> de experiencia en los procesos de Tasación, Comercialización, Alquiler y Administración de Inmuebles avalan nuestro trabajo y dedicación a lo que nos gusta hacer.</p>
            </div>

            <div class="col-xs-6 col-md-6">
                <p>San Martín 55, San Nicolas de los arroyos, Buenos Aires</p>
                <div class="mapa">
                    <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3333.4691017488453!2d-60.222662685240486!3d-33.33269239886342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7678e65a74007%3A0x57f09d3f62d57559!2sSan%20Mart%C3%ADn%2055%2C%20San%20Nicol%C3%A1s%20de%20Los%20Arroyos%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1619709737024!5m2!1ses-419!2sar"
                        width="100%" height="1%00" style="border:0;" allowfullscreen="" loading="lazy"></iframe> -->
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.2159242811244!2d-60.22445487137723!3d-33.332016618636125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7678ddf7e09d5%3A0xaabc08b18fa667e9!2sSan%20Mart%C3%ADn%2055%2C%20B2900HAA%20San%20Nicol%C3%A1s%20de%20Los%20Arroyos%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1758046459836!5m2!1ses-419!2sar" width="100%"  style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                    <!-- <app-map></app-map> -->
                </div>
            </div>

            <div class="col-xs-6 col-md-3">
                <!-- <h6>Contacto</h6> -->
                <p><span>Tel/Fax:</span> +54 0336 4422127</p>
                <p><span>E-mail:</span> info&#64;inmobiliariaprimo.com.ar</p>
                <p><span>Web:</span> www.inmobiliariaprimo.com.ar</p>
            </div>
        </div>
        <hr>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-8 col-sm-6 col-xs-12">
                <p class="copyright-text">&copy; 2021 Todos los derecho reservados
                    <a href="#">Inmobiliaria Primo</a>.
                </p>
            </div>

            <div class="col-md-4 col-sm-6 col-xs-12">
                <ul class="social-icons">
                    <li><a class="facebook" href="https://www.facebook.com/inmobiliariaprimo" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                    <li><a class="instagram" href="https://www.instagram.com/inmobiliariaprimo" target="_blank"><i class="fab fa-instagram"></i></a></li>
                    <li><a class="whatsaap" href="https://api.whatsapp.com/send?phone=5493364521158&text=Contacto - Hola, quisiera" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                    <!-- <li><a class="linkedin" href="#"><i class="fab fa-linkedin"></i></a></li> -->
                </ul>
            </div>
        </div>
    </div>
</footer>